import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "IRS_STATE_REJECTED/FEDERAL_RESUBMIT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setReferenceNumberList: (state, action) => {
            state.referenceNumberList = action.payload;
        },

        setSelectedReferenceNumber: (state, action) => {
            state.selectedReferenceNumber = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setFederealResubmitGridData: (state, action) => {
            state.federealResubmitGridData = action.payload;
        },

        setSelectedFederealResubmitGridData: (state, action) => {
            state.selectedFederealResubmitGridData = action.payload;
        },

        setDownloadAllPDFModal: (state, action) => {
            state.downloadAllPDFModal = action.payload;
        },

        setDownloadMultiplePDFModal: (state, action) => {
            state.downloadMultiplePDFModal = action.payload;
        },

        setResubmitSuccessModal: (state, action) => {
            state.resubmitSuccessModal = action.payload;
        },

        setMergeFormsCheckbox: (state, action) => {
            state.mergeFormsCheckbox = action.payload;
        },

    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        //Filters
        referenceNumberList: [],
        selectedReferenceNumber: { label: "", value: "" },

        //Grid
        federealResubmitGridData: [],
        selectedFederealResubmitGridData: [],

        mergeFormsCheckbox: false,

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            SearchByTIN: "",
            SearchByName: "",
            IsDesc: true,
            Skip: 0,
            total: 10,
        },

        //Modals
        downloadAllPDFModal: false,
        downloadMultiplePDFModal: false,
        resubmitSuccessModal: false,
    }
})

export const { setLoadingState, setReferenceNumberList, setSelectedReferenceNumber, setPaginationState, setFederealResubmitGridData, setSelectedFederealResubmitGridData, setDownloadAllPDFModal, setDownloadMultiplePDFModal, setResubmitSuccessModal, setMergeFormsCheckbox } = actions; 
